<template>
  <div>
    <scenario-block
      :scenario="suggestedScenarioUnion"
      :displayHeader="false"
      v-on="$listeners"
    />

    <v-row
      dense
      justify="start"
      class="elevation-1 px-3 mx-1 py-4 my-5 grey lighten-2"
    >
      <v-col cols="12">
        <h3 class="pa-3">{{ $t("conflict.cohere") }}</h3>
      </v-col>
    </v-row>
    <v-row justify="center">
        <v-btn
          @click="yesFunction"
          color="primary"
          outlined
          tile
          class="px-9"
          height="50px"
          style="margin-left:20px;"
        >
          {{ $t("conflict.yes") }}
        </v-btn>
        <v-btn
          @click="noFunction"
          color="primary"
          outlined
          tile
          class="px-9"
          height="50px"
          style="margin-left:20px;"
        >
         {{ $t("conflict.no") }}   
        </v-btn>
    </v-row>
  </div>
</template>

<script>
import ScenarioBlock from '@/components/global/ScenarioBlock';
import _ from 'lodash';

function sameId(o1, o2) {
  return  o1.id === o2.id;
}

export default {
  name: "ConflictScenarioMultiple",

  components: {  ScenarioBlock },

  mixins: [],

  props: {
    piPref : {
      type: Object,
      required: true,
    },
    pjPref : {
      type: Object,
      required: true,
    }
  },

 /*  data() {
    return {

    }
  }, */

  computed: {
    suggestedScenarioUnion() {
      return {
        //can't use Set() here to deduplicate -> doesn't work
        elements: _.uniqWith([...this.piPref.scenario.elements, ...this.pjPref.scenario.elements], sameId)
      };
    },
    showLogicalLanguage () {
      return this.$store.state.showLogicalLangage;
    },
  },

  methods: {
    
    noFunction () {
        this.$emit('nextTodo')
    },

    yesFunction () {
      this.$emit("addTodo", {
        elementsList: _.uniqWith([...this.piPref.scenario.elements, ...this.pjPref.scenario.elements], sameId),
        workingPreferences: {
          pref1: this.piPref,
          pref2: this.pjPref
        },
        todo: "f_6_01(Pi,Pj)"
      });
      this.$emit("nextTodo");
    }

  },
  created() {
    this.projectId = this.$route.params.id;
  },
};
</script>
